// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext, useState, useEffect, ComponentPropsWithRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SupportIcon from '../assets/support-icon.svg';
import CommonContext from '../../../contexts/CommonContext';
import S from './style';
import { Formik } from 'formik';
import { getMultilang } from '../../../components/common/Multilang';
import ErrorImg from '../../../assets/images/pic_error_internet.svg';
import SentImg from '../assets/sent-icon.svg';
import { Link } from 'react-router-dom';
import { SupportType } from '../../../types/Model';
import DragField from '../DragField';

const Banner: React.FC<ComponentPropsWithRef<'div'>> = (props) => {
  return (
    <S.Banner {...props}>
      <S.BannerText><FormattedMessage id="I001" values={{ br: <br/> }}/></S.BannerText>
    </S.Banner>
  )
}

interface CreateNewSupportProps {
  createNewSupport: (message: string, imagesFiles: File[], title: string, supportTypes: SupportType) => void;
  isLoadingCreateNew: boolean;
  errorsCreateNew: Error | undefined;
}
interface ImageUpload {
  urls: string;
  file: File;
}
const NewSupportForm = (props: CreateNewSupportProps): JSX.Element => {
  const intl = useIntl();
  const common = useContext(CommonContext);
  const { createNewSupport, isLoadingCreateNew, errorsCreateNew } = props;
  const [sent, setSent] = useState(false);
  const [listImagePreviewUrls, setListImagePreviewUrl] = useState<ImageUpload[]>([]);
  const [displayDragField, setDisplayDragField] = useState<boolean>(false);
  const supportTypes = common.supportTypes.map(supportTypes => ({
    id: supportTypes,
    label: intl.formatMessage({ id: supportTypes }),
    value: supportTypes
  }))
  console.log({common})
  useEffect(() => {
    if (isLoadingCreateNew) {
      // setInputMessage('Sending')
    } else {
      // setInputMessage('')
    }
  }, [isLoadingCreateNew])

  function validate(values: any) {
    const errors: any = {};
    if (values.category === '') {
      errors.category = 'Required';
    }
    if (values.title === '') {
      errors.title = 'Required';
    }
    if (values.message === '') {
      errors.message = 'Required';
    }
    return errors;
  }
  const dragOver = (e: any) => {
    e.preventDefault();
    // setDisplayDragField(false)
  }

  const dragEnter = (e: any) => {
    e.preventDefault();
    setDisplayDragField(true)
  }

  const dragLeave = (e: any) => {
    e.preventDefault();
    // setDisplayDragField(false)
  }

  const imagePreview = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const url = reader.result as string;
      setListImagePreviewUrl(data => [...data, { urls: url, file }])
    };
  }
  const fileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer) {
      const files = e.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        imagePreview(files[i])
      }
    }
    setDisplayDragField(false)
    // console.log(files);
  }

  if (errorsCreateNew) {
    return (
      <S.Container {...props}>
        <Banner />
        <S.MessageContainer>
          <S.Image src={ErrorImg} style={{ width: '110px', height: '110px' }} />
          <S.TitleText >
            <FormattedMessage id="I018" />
          </S.TitleText>
          <S.DescriptionText style={{ maxWidth: '306px' }}>
            <FormattedMessage id="I019" values={{
              retry: (<S.Resend onClick={() => window.location.reload()}><FormattedMessage id="I019-2" /></S.Resend>),
              br: <br/>
            }} />
          </S.DescriptionText>
          <S.ButtonBackDefault as={Link} to={'/home'}>
            <FormattedMessage id="I020" />
          </S.ButtonBackDefault>
        </S.MessageContainer>
      </S.Container>
    )
  }

  if (sent) {
    return (
      <S.Container {...props}>
        <Banner />
        <S.MessageContainer>
          <S.Image src={SentImg} style={{ width: '64px', height: '67px' }} />
          <S.TitleText><FormattedMessage id="I015" /></S.TitleText>
          <S.DescriptionText style={{ maxWidth: '396px' }}>
            <FormattedMessage id="I016" />
          </S.DescriptionText>
          <S.ButtonBackDefault onClick={() => setSent(false)}>
            <FormattedMessage id="I017" />
          </S.ButtonBackDefault>
        </S.MessageContainer>
      </S.Container>
    )
  }

  return (
    <Formik
      initialValues={{
        supportType: '',
        title: '',
        message: '',
      }}
      onSubmit={async (fields, { setFieldValue }) => {
        console.log(fields);
        if (!isLoadingCreateNew) {
          await createNewSupport(
            fields.message,
            listImagePreviewUrls.map(data => data.file),
            fields.title,
            fields.supportType as SupportType
          );
          setFieldValue('title', '');
          setFieldValue('message', '');
          setListImagePreviewUrl([]);
          setSent(true);
        }
      }}
      validate={validate}
    >
      {({
        errors,
        values,
        handleChange,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <S.Form onSubmit={handleSubmit} autoComplete="off" {...props}>
          <Banner />
          <S.Wrapper
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
          >
            {displayDragField && <DragField />}
            <S.NewSupportField >
              <S.NewSupportFieldHeaderWrapper>
                <S.NewSupportFieldHeaderIcon src={SupportIcon} />
                <S.NewSupportFieldTitle><FormattedMessage id="I002" /></S.NewSupportFieldTitle>
                <S.Dropdown
                  options={supportTypes}
                  name="supportType"
                  value={values.supportType}
                  placeholder={intl.formatMessage({ id: 'I004'})}
                  setFieldValue={setFieldValue}
                />
              </S.NewSupportFieldHeaderWrapper>
              <S.TitleSupportInput
                type="text"
                name="title"
                placeholder={intl.formatMessage({ id: 'I003' })}
                value={values.title}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.title}
              />
              <S.ReplyField
                message={values.message}
                placeholder={intl.formatMessage({ id: 'I011' })}
                onChange={handleChange}
                onBlur={handleBlur}
                listImagePreviewUrls={listImagePreviewUrls}
                setListImagePreviewUrl={setListImagePreviewUrl}
                disabled={!values.supportType || !values.message || !values.title}
              />
            </S.NewSupportField>
          </S.Wrapper>
        </S.Form>
      )
      }
    </Formik >
  );
}

export { NewSupportForm as default }
